<template>
	<div class="topbar fixed">
		<div class="logo">
			<router-link to="/profile">
				<img src="../assets/img/bulevar-small.svg" alt="Bulevar Logo" class="logo" />
			</router-link>
		</div>
	</div>
	<GMapMap :center="center" :zoom="13" :options="options" :disableDefaultUI="true" class="map" @click="openInfo(null)" ref="maps" @zoom_changed="saveMapState" @dragend="saveMapState">
		<GMapMarker :key="index" v-for="(m, index) in markers" 
			:position="m.position" 
			:clickable="true"
			:draggable="false" @click="openInfo(m, index)"
			:icon="getMarkerIcon(index)"
			:options="{ zIndex: 2}"
			>
		</GMapMarker>
		<GMapMarker
			v-if="currentPosition"
			:position="currentPosition"
			:icon="icons['current']"
			:options="{ zIndex: 1}"
		/>
	</GMapMap>
	<div v-if="locationError" class="locationError">
		<p>{{ t('txt_location_not_allowed') }}</p>
	</div>
	<MobileNav :selected="selectedId" :marker="markerData" :partner="partner" />
</template>

<script>
import { keycloak } from '../keycloak';
import { useI18n } from 'vue-i18n';
import { ref } from 'vue';
import apiClient from '../utils/axios';
import dayjs from '@/utils/dayjs';

export default {
	data() {
		return {
			mapInstance: null,
			partner: 0,
			markerData: null,
			positionWatcher: null,
			locationError: false,
			selectedId: 1,
			selectedMarkerIndex: null,
			center: { lat: 45.95157785677234, lng: 13.6374399806582 },
			icons: {
				selected: require('../assets/img/pin-selected.svg'),
				point: require('../assets/img/pin.svg'),
				done: require('../assets/img/pin-done.svg'),
				doneselected: require('../assets/img/pin-selected-done.svg'),
				current: require('../assets/img/current.svg'),
			},
			markers: [],
			options: {
				streetViewControl: false,
				zoomControl: false,
				scaleControl: false,
				mapTypeControl: false,
				fullscreenControl: false,
				styles: [
							{
								"featureType": "all",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#202c3e"
									}
								]
							},
							{
								"featureType": "all",
								"elementType": "labels.text.fill",
								"stylers": [
									{
										"gamma": 0.01
									},
									{
										"lightness": 20
									},
									{
										"weight": "1.39"
									},
									{
										"color": "#ffffff"
									}
								]
							},
							{
								"featureType": "all",
								"elementType": "labels.text.stroke",
								"stylers": [
									{
										"weight": "0.96"
									},
									{
										"saturation": "9"
									},
									{
										"visibility": "on"
									},
									{
										"color": "#000000"
									}
								]
							},
							{
								"featureType": "all",
								"elementType": "labels.icon",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "geometry",
								"stylers": [
									{
										"lightness": 30
									},
									{
										"saturation": "9"
									},
									{
										"color": "#2a2e43"
									},
									{
										"visibility": "on"
									},
									{
										"weight": "1"
									}
								]
							},
							{
								"featureType": "landscape",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "landscape.man_made",
								"elementType": "geometry",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "landscape.man_made",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"visibility": "simplified"
									},
									{
										"weight": "4.79"
									},
									{
										"hue": "#ff0000"
									},
									{
										"gamma": "1.27"
									}
								]
							},
							{
								"featureType": "landscape.man_made",
								"elementType": "geometry.stroke",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"color": "#ffffff"
									},
									{
										"weight": "1"
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "poi",
								"elementType": "geometry",
								"stylers": [
									{
										"saturation": 20
									},
									{
										"visibility": "simplified"
									}
								]
							},
							{
								"featureType": "poi.park",
								"elementType": "geometry",
								"stylers": [
									{
										"lightness": 20
									},
									{
										"saturation": -20
									},
									{
										"color": "#2a2e43"
									}
								]
							},
							{
								"featureType":"road",
								"elementType":"geometry",
								"stylers":[
									{
										"color":"#29ccb1"
									},{
										"visibility":"on"
									},{
										"saturation":0
									}
								]
							},							
							{
								"featureType": "transit",
								"elementType": "geometry",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "transit.line",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"gamma": "0.52"
									},
									{
										"lightness": "-56"
									},
									{
										"saturation": "-60"
									}
								]
							},
							{
								"featureType": "transit.station",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"visibility": "on"
									},
									{
										"color": "#ffffff"
									}
								]
							},
							{
								"featureType": "transit.station.rail",
								"elementType": "all",
								"stylers": [
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "transit.station.rail",
								"elementType": "geometry",
								"stylers": [
									{
										"gamma": "1.00"
									},
									{
										"visibility": "on"
									},
									{
										"color": "#ffffff"
									},
									{
										"weight": "1.76"
									}
								]
							},
							{
								"featureType": "transit.station.rail",
								"elementType": "geometry.fill",
								"stylers": [
									{
										"color": "#ffffff"
									},
									{
										"visibility": "on"
									}
								]
							},
							{
								"featureType": "transit.station.rail",
								"elementType": "labels",
								"stylers": [
									{
										"visibility": "off"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "all",
								"stylers": [
									{
										"lightness": -20
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "geometry",
								"stylers": [
									{
										"color": "#00e6ff"
									}
								]
							},
							{
								"featureType": "water",
								"elementType": "labels",
								"stylers": [
									{
										"color": "#2a2e43"
									}
								]
							}
						],
			},
		}
	},
	setup() {
		const { t, locale } = useI18n();
		const currentPosition = ref(null);

		const changeLanguage = (newLocale) => {
			locale.value = newLocale;
			localStorage.setItem('lang', newLocale);
		};

		return {
			changeLanguage,
			t,
			currentPosition
		};
	},
	mounted() {
		this.isAuthenticated = keycloak.authenticated;
		if (!this.isAuthenticated) {
			this.$router.push('/login');
			return;
		}
		if(!localStorage.getItem('lang')){
			this.$router.push('/');
		}
		this.$refs.maps.$mapPromise.then((map) => {
			const savedCenter = localStorage.getItem('mapCenter')
			const savedZoom = localStorage.getItem('mapZoom')

			if (savedCenter) {
				map.setCenter(JSON.parse(savedCenter));
			}
			if (savedZoom) {
				map.setZoom(Number(savedZoom));
			}
			this.saveMapState()
		});
		try {
			this.fetchPoints();
			this.openInfo({
					data: {
						name: this.t('txt_select_point'),
						description: this.t('txt_select_point_description')
					},
					selected: false
				}
			);
		} catch (error) {
			console.error('Error in setCurrentLocation():', error);
		}
	},
	beforeUnmount() {
		if (this.positionWatcher) {
			navigator.geolocation.clearWatch(this.positionWatcher);
		}
	},
	methods: {
		onMapLoad() {
			this.$refs.maps.$mapPromise.then((map) => {
				map.addListener('dragend', this.saveMapState);
				map.addListener('zoom_changed', this.saveMapState);
			});
		},
		saveMapState() {
			this.$refs.maps.$mapPromise.then((map) => {
				let center = map.getCenter();
				localStorage.setItem(
					'mapCenter',
					JSON.stringify({ lat: center.lat(), lng: center.lng() })
				);
				localStorage.setItem('mapZoom', map.getZoom());
			});
		},
		setCurrentLocation() {
			if (navigator.geolocation) {
				navigator.geolocation.getCurrentPosition(
					(position) => {
						this.currentPosition = {
							lat: position.coords.latitude,
							lng: position.coords.longitude,
						};
					},
					(error) => {
						console.error('Error callback triggered:', error);
					}
				);
			} else {
				console.error('Geolocation is not supported by this browser.');
			}
		},
		startPositionWatch() {
			if (navigator.geolocation) {
				this.positionWatcher = navigator.geolocation.watchPosition(
				(position) => {
					this.locationError = false;
					this.currentPosition = {
						lat: position.coords.latitude,
						lng: position.coords.longitude,
					};
				},
				(error) => {
					this.locationError = true;
					this.handleGeolocationError(error);
				},
				{ enableHighAccuracy: true }
				);
			} else {
				this.locationError = false;
				console.error('Geolocation is not supported by this browser.');
			}
		},
		stopPositionWatch() {
			if (this.positionWatcher !== null) {
				navigator.geolocation.clearWatch(this.positionWatcher);
				console.log('Position watch stopped.');
				this.positionWatcher = null;
			}
		},
		handleGeolocationError(error) {
			switch (error.code) {
				case error.PERMISSION_DENIED:
					this.locationError = true;
					
					break;
				case error.POSITION_UNAVAILABLE:
					console.error('Position unavailable.');
					this.retryLocationRequest();
					break;
				case error.TIMEOUT:
					console.error('Location request timed out.');
					this.retryLocationRequest();
					break;
				default:
					this.locationError = true;
					console.error('An unknown error occurred.');
					break;
			}
		},
		retryLocationRequest() {
			setTimeout(() => {
				this.startPositionWatch();
			}, 3000);
		},
		defineMarkers(pointsList) {
			Object.keys(pointsList).forEach(function(markerCategories) {
				if (['points', 'events'].includes(markerCategories)) {
					pointsList[markerCategories].forEach(function(point) {
						this.markers.push({
							position: {
								lat: parseFloat(point.lat),
								lng: parseFloat(point.lon)
							},
							data: {
								id: point.id,
								name: point.title,
								description: (point.type == 'event') ? this.formatDate(point.event_date) : '',
								type: point.type,
								points: point.sparks,
								done: point.done
							},
							selected: false
						});
					}.bind(this));
				}
			}.bind(this));
		},
		async fetchPoints() {
			try {
				const lang = localStorage.getItem('lang') || 'en';
				const response = await apiClient.get(`/${lang}/api/points?all=true`);
				this.defineMarkers(response.data);
				this.setCurrentLocation();
				this.startPositionWatch();
			} catch (error) {
				console.error('Error fetching point:', error);
			}
		},
		openInfo(marker = null, index = null) {
			if(marker == null){
				this.markerData = null;
			}
			if (this.selectedMarkerIndex !== null && this.selectedMarkerIndex !== index) {
				this.markers[this.selectedMarkerIndex].selected = false;
			}
			if(marker && typeof this.markers[index] != 'undefined'){
				this.markerData = marker;
				this.markers[index].selected = !this.markers[index].selected;
				this.selectedMarkerIndex = this.markers[index].selected ? index : null;
			} else {
				this.markerData = {
					data: {
						name: this.t('txt_select_point'),
						description: this.t('txt_select_point_description')
					},
					selected: false
				};
			}
		},
		getMarkerIcon(index) {
			if (this.markers[index].selected) {
				if(this.markers[index].data.done == 1){
					return this.icons.doneselected;
				} else {
					return this.icons.selected;
				}
			}
			if(this.markers[index].data.done == 1){
				return this.icons.done;
			} else {
				return this.icons.point;
			}
		},
		formatDate(date) {
			return dayjs(date).locale(localStorage.getItem('lang')).format('L LT');
		},
	},
	watch: {
		$route(to) {
			if (to.path === '/map') {
				this.startPositionWatch();
			} else {
				this.stopPositionWatch();
			}
		}
	},
}
</script>

<style>
.fixed {
	position: fixed;
	left: 30px;
	top: 30px;
	z-index: 1049;
}
.map {
	width: 100%;
	height: 100vh;
	height: 100dvh;
}
</style>
